/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export const addProjectParameterData = {

  discipline: ['Common', 'Structural', 'HVAC', 'Energy', 'Electrical', 'Piping', 'Infrastructure'],

  common: [
    'Text',
    'Integer',
    'Number',
    'Length',
    'Area',
    'Volume',
    'Angle',
    'URL',
    'Material',
    'Yes/No',
    'Number Of Poles',
    'Fixture Unit',
    'Load Classification',
    'Image',
    'Multiline Text',
    'Slope',
    'Currency',
    'Mass Density',
    'Time',
    'Speed',
  ],

  structural: [
    'Force',
    'Linear Force',
    'Area Force',
    'Moment',
    'Stress',
    'Unit Weight',
    'Thermal Expansion Coefficient',
    'Linear Moment',
    'Point Spring Coefficient',
    'Rotational Point Spring Coefficient',
    'Line Spring Coefficient',
    'Rotational Line Spring Coefficient',
    'Area Spring Coefficient',
    'Reinforcement Volume',
    'Reinforcement Length',
    'Acceleration',
    'Bar Diameter',
    'Crack Width',
    'Displacement/Deflection',
    'Energy',
    'Frequency',
    'Mass',
    'Mass per Unit Length',
    'Moment of Inertia',
    'Surface Area per Unit Length',
    'Period',
    'Pulsation',
    'Reinforcement Area',
    'Reinforcement Area per Unit Length',
    'Reinforcement Cover',
    'Reinforcement Spacing',
    'Rotation',
    'Section Area',
    'Section Dimension',
    'Section Modulus',
    'Section Property',
    'Velocity',
    'Warping Constant',
    'Weight',
    'Weight per Unit Length',
    'Mass per Unit Area',
  ],

  hvac: [
    'Density',
    'Friction',
    'Power',
    'Power Density',
    'Pressure',
    'Temperature',
    'Velocity',
    'Air Flow',
    'Duct Size',
    'Cross Section',
    'Heat Gain',
    'Roughness',
    'Dynamic Viscosity',
    'Air Flow Density',
    'Cooling Load',
    'Cooling Load divided by Area',
    'Cooling Load divided by Volume',
    'Heating Load',
    'Heating Load divided by Area',
    'Heating Load divided by Volume',
    'Air Flow divided by Volume',
    'Air Flow divided by Cooling Load',
    'Area divided by Cooling Load',
    'Slope',
    'Area divided by Heating Load',
    'Factor',
    'Duct Insulation Thickness',
    'Duct Lining Thickness',
    'Temperature Difference',
  ],

  energy: [
    'Energy',
    'Coefficient of Heat Transfer',
    'Thermal Resistance',
    'Thermal Mass',
    'Thermal Conductivity',
    'Specific Heat',
    'Specific Heat of Vaporization',
    'Permeability',
  ],

  electrical: [
    'Current',
    'Electrical Potential',
    'Frequency',
    'Illuminance',
    'Luminous Flux',
    'Power',
    'Apparent Power',
    'Power Density',
    'Wire Diameter',
    'Efficacy',
    'Wattage',
    'Color Temperature',
    'Luminous Intensity',
    'Luminance',
    'Temperature',
    'Cable Tray Size',
    'Conduit Size',
    'Demand Factor',
    'Electrical Resistivity',
    'Temperature Difference',
  ],

  piping: [
    'Density',
    'Flow',
    'Friction',
    'Pressure',
    'Temperature',
    'Velocity',
    'Dynamic Viscosity',
    'Pipe Size',
    'Roughness',
    'Volume',
    'Slope',
    'Pipe Insulation Thickness',
    'Pipe Dimension',
    'Mass',
    'Mass per Unit Length',
    'Temperature Difference',
  ],

  infrastructure: ['Stationing']
};
